import axios from "axios";
import {URL} from "util/socket";

export default axios.create({
  baseURL: `${URL}/`, //YOUR_API_URL HERE
  headers: {
    "Content-Type": "application/json"
  }
});
